import { EyeOutlined, LockOutlined } from "@ant-design/icons"
import { Button, Flex, Typography } from "antd"
import React from "react"

const { Title, Text } = Typography

interface GccOwnerLockOverlayProps {
  onTransferOwnership?: () => void
  onViewPermissions?: () => void
  hideActions?: boolean
}

export function GccOwnerLockOverlay({
  onTransferOwnership,
  onViewPermissions,
  hideActions
}: GccOwnerLockOverlayProps) {
  return (
    <Flex
      vertical
      align="center"
      justify="center"
      gap={16}
      className="flex-1 relative text-center p-8"
    >
      <div
        className={
          "border-border border-2 shadow-sm rounded-card inset-0  absolute"
        }
      >
        <div className={"size-full blur-sm -z-10 bg-white/20"} />
      </div>
      <LockOutlined style={{ fontSize: 40 }} className="text-gray-400" />
      <Flex vertical gap={8} align="center" className="max-w-sm">
        <Title level={4} className="m-0">
          GCC Owner permissions are protected
        </Title>
        <Text type="secondary">
          Core permissions of the GCC Owner cannot be modified to prevent
          organization lockout.
          {!hideActions &&
            "To reassign this role, use the Transfer Ownership flow."}
        </Text>
      </Flex>
      {!hideActions && (
        <Flex gap={8} align="center">
          <Button type="primary" onClick={onTransferOwnership}>
            Transfer Ownership
          </Button>
          <Button
            type="text"
            icon={<EyeOutlined />}
            onClick={onViewPermissions}
          >
            View permissions
          </Button>
        </Flex>
      )}
    </Flex>
  )
}
